<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <!-- <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p> -->
          <div class="totals-box plr24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum jishi">{{ form.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">出库日期</div>
              <div class="itemNum">{{formatDay(form.billTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">出库原因</div>
              <div class="itemNum">{{ form.billCategoryName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请时间</div>
              <div class="itemNum">{{formatDate(form.createTime)}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请人</div>
              <div class="itemNum">{{ form.createName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">备注</div>
              <div class="itemNum huanxin">{{ form.remark }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.imgUrlList.length > 0">
                <div class="itemName">出库照片</div>
                <el-image
                  class="preImg"
                  v-for="(item,index) in form.imgUrlList"
                  :src="item"
                  :key="index"
                  :preview-src-list="form.imgUrlList"
                ></el-image>
              </div>
          </div>

          <div v-if="form.itemList && form.itemList.length != 0">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>出库产品信息</i></p>
            <div class="detail plr20">
              <el-table :data="form.itemList" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="productName" label="产品名称" width="auto"></el-table-column>
                <el-table-column prop="storageUnit" label="出库单位" width="auto"></el-table-column>
                <el-table-column prop="itemNum" label="出库数量" width="auto" align="right"></el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="form.auditStatus != 'cancel'">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>审核流程</i></p>
            <div class="flex-row mlr24" v-for="item,index in form.flowAuditRecordList" :key="index">
              <div class="process-left">
                <div class="process-boxs">
                  <div class="process-img">
                    <img :src="item.headImgUrl" alt="" v-if="item.headImgUrl">
                    <img src="../../../assets/images/staffJounary_headerImg.png" alt="" v-else>
                    <div class="audit-img">
                      <img src="../../../assets/images/audit_success.png" alt="" v-if="item.auditStatus == 'pass'">
                      <img src="../../../assets/images/audit_wait.png" alt="" v-else-if="item.auditStatus == 'wait'">
                      <img src="../../../assets/images/audit_refuse.png" alt="" v-else-if="item.auditStatus == 'refuse'">
                    </div>
                  </div>
                  <div class="process-vertical" v-if="form.flowAuditRecordList.length - index != 1"></div>
                </div>
              </div>
              <div class="ml16 w100b process-right">
                <div class="align-items color999 f12">
                  <div>{{item.flowNodeName}}</div>
                  <div>{{formatDate(item.auditTime)}}</div>
                </div>
                <div class="mt5 f16" :class="[form.flowAuditRecordList.length - index != 1 ? 'mb40':'mb20']">{{item.auditOpName}}<span v-if="item.auditStatus">（{{item.auditStatusCn}}）</span></div>
                <div class="process-refuse" v-if="item.auditStatus == 'refuse'">{{item.auditRemark}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10" style="display: flex;align-items: center;">
            <el-button type="danger" v-if="form.refuseFlag" class="small-btn" @click="cancel('refuse')">拒绝</el-button>
            <el-button type="primary" v-if="form.agreeFlag" class="small-btn" @click="cancel('pass')">同意</el-button>
            <el-button type="warning" v-if="form.cancelFlag" class="small-btn" @click="cancel('cancel')">撤销</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      optionName: [], // 请假人
      allStaffList: [], // 请假类型
      form: {
        id: "",
        imgUrlList: [],
        flowAuditRecordList: [],
        auditStatusCn: '',
      },
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.$api.get(this.$url.inventoryWastageInfo.get,{id: org.id}).then(res => {
          if (res) {
            res.auditStatusCn = res.auditStatusCn || '';
            res.imgUrlList = res.imgUrlList || [];
            this.form = res
          }
        })
        this.addEditShow = true;
        this.addEditTitle = "出库详情";
      });
    },
    
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    cancel (value) {
      let msg;
        if (value == 'refuse') {
          msg = `确定要拒绝吗?`
        } else if (value == 'pass') {
          msg = `确定要同意吗?`
        } else {
           msg = `确定要撤销吗?`
        }
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null,[
            h('span', { style: 'color: red' }, msg)
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(action => {
          if (value == 'pass' || value == 'refuse') {
            this.$api.post(this.$url.companyLeave.audit, {id: this.form.id,auditStatus: value}).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            }).catch(error => {});
          } else {
            this.$api.post(this.$url.inventoryWastageInfo.recall, {id: this.form.id}).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("撤销成功");
                this.$emit("change", true);
              }
            }).catch(error => {});
          }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.process-boxs {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.process-img {
  width: 40px;
  height: 40px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.audit-img {
  width: 14px;
  height: 14px;
  position: absolute;
  right: 0;
  bottom: 0;
    img {
    width: 100%;
    height: 100%;
  }
}
.process-vertical {
  width: 2px;
  height: 32px;
  margin: 4px 0;
  background: #E6E6E6;
}
.process-right {
  .process-refuse {
    padding: 12px;
    margin-top: 8px;
    color: #666;
    background: #F2F1F6;
    border-radius: 4px;
  }
}

.toggle-text {
  padding: 0 20px;
}
.refund_box {
    background: #fff;
    padding: 10px 20px;
    
    .infos {
      color: #ff892a;
      padding-bottom: 10px;
    }
}
.leaveBox {
  background: #fff;
  padding: 10px 20px;
}
.member_bg {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .el-dialog {
  margin-top: 20vh !important;
}
.pay-mains {
  padding: 0;

  .preImg {
    border-radius: 5px;
    margin: 0 10px 10px 0;
    width: 80px;
    height: 80px;
  }

  .card-ruleForm {
    padding-bottom: 0;
    padding-top: 10px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
      
    }
    .item-cards {
      background: #fff;
      padding: 20px;
      /deep/ .el-form-item__content {
        flex: 2;
        // text-align: right;
        // display: flex;
        margin-left: 0 !important;
        .el-form-item__error {
          right: 0;
        }
      }
    }
    .el-form-item-update {
      align-items: center;
      display: flex;
      margin: 0;
      // justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      background: #fff;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;

        margin-left: 0 !important;
        .el-form-item__error {
          z-index: 1;
          right: 0;
        }
      }

      /deep/ .el-input__inner {
        width: 200px;
          text-align: left;
        // text-align: right;
      }
      
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .head-img {
    //   height: 90px;
        padding: 10px;
      background: #fff;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dceaed;
      /deep/ .el-form-item__content {
        .top-img {
          width: 100%;
          border-radius: 50%;
          .text-upload {
            position: absolute;
            top: 20px;
            right: 0;
            line-height: initial;
          }
        }
        .el-link {
          width: auto;
          cursor: pointer;
        }
        .img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
  
}
.moneys {
    color: red !important;
}
</style>